import type { Components } from '@mui/material';

import { horizonTheme } from './horizon-theme';

export const muiSwitch: Components<typeof horizonTheme>['MuiSwitch'] = {
  styleOverrides: {
    root: {
      width: 50,
      height: 27,
      padding: 0,
      margin: 2,
    },
    thumb: {
      width: 23,
      height: 23,
    },
    switchBase: ({ theme }) => ({
      padding: '2px',
      '&.Mui-checked': {
        transform: 'translateX(23px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.blue.main,
        },
      },
    }),
    track: ({ theme }) => ({
      borderRadius: 36 / 2,
      backgroundColor: theme.palette.gray800.main,
      '.Mui-checked.Mui-checked + &': {
        backgroundColor: theme.palette.blue.main,
      },
    }),
  },
};
